import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode"; // default export

const Home = () => {
  /* ─ state ─ */
  const [productCount, setProductCount] = useState(0);
  const [banners, setBanners] = useState([]);
  const [orderStats, setOrderStats] = useState({
    Pending: 0,
    Printing: 0,
    Packing: 0,
    Dispatched: 0,
    Cancelled: 0,
  });
  const navigate = useNavigate();

  /* ─ fetches ─ (unchanged, trimmed for brevity) */
  useEffect(() => {
    const token = localStorage.getItem("token");
    let userId = null;
    try {
      const d = jwtDecode(token);
      userId = d?.user?.userId || d?.userId || d?._id;
    } catch {}
    (async () => {
      try {
        const res = await fetch(
          "https://api.vyapakprint.com/api/banner/getBanners"
        );
        const data = await res.json();
        setBanners(
          Array.isArray(data) ? data.sort((a, b) => a.index - b.index) : []
        );
      } catch (err) {
        console.error(err);
      }
    })();

    /* product count */
    (async () => {
      try {
        const res = await fetch(
          "https://api.vyapakprint.com/api/businessProducts/getAllBusinessProducts"
        );
        const data = await res.json();
        setProductCount(Array.isArray(data) ? data.length : 0);
      } catch (err) {
        console.error(err);
      }
    })();

    /* order stats just for that user */
    (async () => {
      if (!userId) return;
      const res = await fetch(
        "https://api.vyapakprint.com/api/businessOrders/getAllBusinessOrders"
      );
      const data = await res.json();
      const mine = (data.BusinessOrders || []).filter(
        (o) => o.userId === userId
      );
      const cnt = mine.reduce((a, o) => {
        a[o.status] = (a[o.status] || 0) + 1;
        return a;
      }, {});
      setOrderStats((s) => ({ ...s, ...cnt }));
    })();
  }, []);

  /* ─ nav helpers ─ */
  const handlePlaceOrder = () => navigate("/products");
  const handleStatusClick = (status) =>
    navigate(`/order-status?status=${status}`);
  //   ↳ switch to `/order-status/${status}` if you prefer a path param

  /* ─ cards config ─ */
  const cards = [
    {
      key: "place",
      title: "Place Order",
   
      description: "नया ऑर्डर यहाँ पर दें।",
      icon: "fas fa-plus-circle",
      color: "bg-blue-500",
      onClick: handlePlaceOrder,
    },
    {
      key: "Pending",
      title: "Pending",
      count: orderStats.Pending,
      description: "Awaiting processing",
      icon: "fas fa-hourglass-half",
      color: "bg-yellow-500",
      onClick: () => handleStatusClick("Pending"),
    },
    {
      key: "Printing",
      title: "Printing",
      count: orderStats.Printing,
      description: "Jobs in print",
      icon: "fas fa-print",
      color: "bg-indigo-500",
      onClick: () => handleStatusClick("Printing"),
    },
    {
      key: "Packing",
      title: "Packing",
      count: orderStats.Packing,
      description: "Being packed",
      icon: "fas fa-box-open",
      color: "bg-purple-500",
      onClick: () => handleStatusClick("Packing"),
    },
    {
      key: "Dispatched",
      title: "Dispatched",
      count: orderStats.Dispatched,
      description: "On the way",
      icon: "fas fa-truck-moving",
      color: "bg-green-500",
      onClick: () => handleStatusClick("Dispatched"),
    },
    {
      key: "Cancelled",
      title: "Cancelled",
      count: orderStats.Cancelled,
      description: "Orders cancelled",
      icon: "fas fa-times-circle",
      color: "bg-red-500",
      onClick: () => handleStatusClick("Cancelled"),
    },
  ];

  /* ─ carousel settings (unchanged) ─ */
  const carouselSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  /* ─ render ─ */
  return (
    <div className="container mx-auto p-6">
      {/* carousel */}
      <div className="mb-8">
        <Slider {...carouselSettings}>
          {banners.length
            ? banners.map(({ _id, url }, i) => (
                <div
                  key={_id ?? i}
                  className="flex justify-center items-center bg-gray-100 rounded-lg overflow-hidden"
                >
                  <img
                    src={url}
                    alt={`Banner ${i + 1}`}
                    className="object-cover w-full h-full"
                  />
                </div>
              ))
            : [1, 2].map((n) => (
                <div
                  key={n}
                  className="flex justify-center items-center h-64 bg-gray-200 rounded-lg"
                >
                  <h2 className="text-2xl font-semibold">{`Carousel Slide ${n}`}</h2>
                </div>
              ))}
        </Slider>
      </div>

      {/* cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
        {cards.map((card) => (
          <div
            key={card.key}
            className={`p-6 rounded-lg shadow-lg ${card.color} text-white flex items-center cursor-pointer`}
            onClick={card.onClick}
          >
            <i className={`${card.icon} text-3xl mr-4`} />
            <div>
              <h3 className="text-xl font-semibold">{card.title}</h3>
              <p className="text-sm">{card.description}</p>
              <p className="text-2xl font-bold mt-2">{card.count}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Home;
